import React from 'react';
import { ItemList } from './item-list';
import { useAppDispatch } from 'tradera/state/hooks';
import { getItemQuery } from 'tradera/state/views/start-page/actions';
import { useOnMount } from 'tradera/hooks/use-on-mount';
import type { ItemListType } from 'tradera/state/views/start-page/item-queries';
import { useFeatureValue } from '@growthbook/growthbook-react';
export const RandomItemList = () => {
    const dispatch = useAppDispatch();
    const [itemQuery, setItemQuery] = React.useState<ItemListType>();

    const featureValue = useFeatureValue(
        'tgl-339-a-a-b-item-lists-start-page',
        'disabled'
    );

    const itemListExperimentEnabled = featureValue === 'enabled';

    useOnMount(() => {
        if (itemListExperimentEnabled) {
            const query = dispatch(getItemQuery());
            if (query) {
                setItemQuery(query);
            } else {
                console.warn('Missing item query for item list on startpage');
            }
        }
    });

    if (!itemQuery) {
        return null;
    }

    return (
        <ItemList
            title={itemQuery?.title}
            queryType={itemQuery.queryType}
            queryParams={itemQuery.queryParams}
        />
    );
};
